import { render, staticRenderFns } from "./AlbumEditPage.vue?vue&type=template&id=9c319da8&lang=pug&"
import script from "./AlbumEditPage.vue?vue&type=script&lang=js&"
export * from "./AlbumEditPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports